import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './auth/context/AuthContext';
import TiposPregunta from './pages/tipospregunta/TiposPregunta';
import Temas from './pages/temas/Temas';
import TiposDato from './pages/tiposdato/TiposDato';
import EncuestaConductor from './pages/conductor/EncuestaConductor';
import Login from './pages/login/Login';
import Empresas from './pages/empresas/Empresas';
import Host from './pages/host/Host';
import EmpresasCodigo from './pages/empresas/codigo/EmpresasCodigo';
import Usuarios from './pages/usuarios/Usuarios';
import Encuestas from './pages/encuestas/Encuestas';
import Preguntas from './pages/encuestas/preguntas/Preguntas';
import Respuestas from './pages/encuestas/preguntas/respuestas/Respuestas';
import Manifiestos from './pages/OnRoad/Manifiestos';
import NotFound from './pages/NotFound';
import PrincipalOnRoad from './pages/OnRoad/PrincipalOnRoad';
import ValidarConductor from './pages/OnRoad/ValidarConductor';
import OnRoadProtectedLayout from './components/globales/OnRoadProtectedLayout';
import ProtectedLayout from './components/globales/ProtectedLayout';
import Vinculacion from './pages/vinculacion/Vinculacion';
import Home from './pages/Home'

function App() {
	return (
		<AuthProvider>
			<Router>
				<ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                />
				<Routes>
					<Route path="/login" element={<Login />} />
					<Route path="/encuesta-conductor/:token" element={<EncuestaConductor />} />
                    <Route path="/onroad/:tenantEmpresa" element={<ValidarConductor />}/>
                    <Route path="/vinculacion/:tenant" element={<Vinculacion />} />
                    <Route element={<OnRoadProtectedLayout />}>
                        <Route path="/principalonroad" element={<PrincipalOnRoad />}/>
                    </Route>
					<Route path="/*" element={<ProtectedLayout />}>
                        <Route index element={<Home />} />
                        <Route path="inicio" element={<Home />} />

                        <Route path="empresas" element={<Empresas />} />
                        <Route path="host" element={<Host />} />
                        <Route path="empresas-codigo/:id" element={<EmpresasCodigo />} />
                        <Route path="usuarios" element={<Usuarios />} />
                        <Route path="encuestas" element={<Encuestas />} />
                        <Route path="preguntas/:id" element={<Preguntas />} />
                        <Route path="respuestas/:id" element={<Respuestas />} />
                        <Route path="manifiestos" element={<Manifiestos />} />

                        <Route path="temas" element={<Temas />} />
                        <Route path="tipo-pregunta" element={<TiposPregunta />} />
                        <Route path="tipo-dato" element={<TiposDato />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
				</Routes>
			</Router>
		</AuthProvider>
	);
};

export default App;